// @ts-check

import { useIncidentTemplateDataGridContext } from '~/components/Incidents/IncidentTemplateDataGrid/IncidentTemplateDataGrid.context';
import GridExportButton from '~/components/Shared/DataGrid/GridExportButton';

const EXPORTED_ROW_COUNT = 150;

export default function IncidentTemplateDataGridExportButton() {
    const { gridRef, setRowCount } = useIncidentTemplateDataGridContext();

    return (
        <GridExportButton
            gridRef={gridRef}
            setRowCount={setRowCount}
            exportRowCount={EXPORTED_ROW_COUNT}
            fileName="ZERO Incident Templates Export"
        />
    );
} 